export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Incoming',
    i18nKey: 'INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Outgoing',
    i18nKey: 'OUTGOING',
  },
];

// Ids are Ruby's Time#wday, so Sunday is 0. AutomationRules::TimeConditionEvaluator compares against the
// same numbering, which is also what WorkingHour#day_of_week uses.
// They are strings because filterQueryGenerator's setArrayValues tests `values[0]?.id` for truthiness, and a
// numeric 0 would make it ship the whole option objects instead of their ids.
export const DAY_OF_WEEK_CONDITION_VALUES = [
  { id: '0', name: 'Sunday', i18nKey: 'SUNDAY' },
  { id: '1', name: 'Monday', i18nKey: 'MONDAY' },
  { id: '2', name: 'Tuesday', i18nKey: 'TUESDAY' },
  { id: '3', name: 'Wednesday', i18nKey: 'WEDNESDAY' },
  { id: '4', name: 'Thursday', i18nKey: 'THURSDAY' },
  { id: '5', name: 'Friday', i18nKey: 'FRIDAY' },
  { id: '6', name: 'Saturday', i18nKey: 'SATURDAY' },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'None',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Low',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Medium',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'High',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgent',
    i18nKey: 'URGENT',
  },
];
